import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import AppDrawer from "./AppDrawer";
import { useHistory, useLocation } from "react-router";
import { AppDrawerSet } from "~slices/AppDrawer";

import { useDispatch, useSelector } from "react-redux";

import { LogoutBack } from "../../stores/slices/Login";
import { logout } from "../../stores/Information";
import Avatar from "@mui/material/Avatar";

export default function AppNaviBar() {
    const dispatch = useDispatch();
    const app_drawer_state = useSelector((state) => state.AppDrawer);

    const history = useHistory();
    const location = useLocation();

    const informationState = useSelector((state) => state.Information);

    const LoginClick = () => {
        history.push(`/Login`);
    };

    //幹事ログアウト
    const LogoutClick = () => {
        dispatch(LogoutBack({login_token: informationState["organizer"]["login_token"]}));
        dispatch(logout(["organizer"]));
        
        history.push(`/`);
    };

    //会員登録
    const EntranceUserClick = () => {
        history.push(`/EntranceUser`);
    };

    const DrawerOpen = () => {
        dispatch(AppDrawerSet(["open", true]));
    };
    const DrawerClose = () => {
        dispatch(AppDrawerSet(["open", false]));
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppDrawer open={app_drawer_state.open} onClose={DrawerClose} />
            <AppBar position="static" color="primary">
                <Toolbar>
                    {/* ハンバーガーメニューは幹事のみ・参加者は無し */}
                    {location.pathname.startsWith("/Member/") ? "" : (
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2 }}
                            onClick={DrawerOpen}
                        >
                            <MenuIcon />
                        </IconButton>
                    )}

                    <Avatar alt="icon" src="/images/Logo/新_透過ロゴ.png" />
                    <Typography variant={location.pathname.startsWith("/Member/") ? "body1" : "h6"} component="div" sx={{ flexGrow: 1 }}>
                        オンライン懇親会セット予約システム
                    </Typography>

                    {location.pathname.startsWith("/Member/") ? (
                        ""
                    ) : (
                        <>
                            <Button color="inherit" onClick={EntranceUserClick} style={{ display: informationState["organizer"]["user_login"] === true ? 'none' : '' }}>
                                会員登録
                            </Button>
                            <Button color="inherit" onClick={LoginClick} style={{ display: informationState["organizer"]["user_login"] === true ? 'none' : '' }}>
                                Login
                            </Button>
                            <Button color="inherit" onClick={LogoutClick} style={{ display: informationState["organizer"]["user_login"] === true ? '' : 'none' }}>
                                Logout
                            </Button>
                        </>
                    )}  
                </Toolbar>
                {location.pathname.startsWith("/Member/") ? (
                    <Toolbar variant="string" sx={{justifyContent: "end", backgroundColor: "#3bc3f2", pr: "5px"}}>
                        <Button color="inherit" href="https://www.cfs.co.jp/privacy/" target="_blank" rel="noreferrer">
                            プライバシーポリシー
                        </Button>
                    </Toolbar>
                ) : ""}                
            </AppBar>
        </Box>
    );
}
